import APIUtils from '@spothero/utils/api';

const FavoriteAPI = {
    getFavorites(userId) {
        return APIUtils.get(`users/${userId}/favorite-facilities/`, {
            include: 'images,last_reservation,city_relative_url'
        });
    },

    update({userId, facilityId, isFavorite}) {
        return APIUtils.post(`users/${userId}/favorite-facilities/`, {
            facility: facilityId,
            favorite: isFavorite
        });
    }
};

export default FavoriteAPI;
